'use client'

import { AuthProvider } from '@/contexts/AuthContext'
import { FavoriteServicesProvider } from '@/contexts/FavoriteServicesContext'
import { PlannerEventProvider } from '@/contexts/PlannerEventContext'
import { Toaster } from 'sonner'

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      <FavoriteServicesProvider>
      <PlannerEventProvider>
        {children}
        <Toaster duration={5000} position="top-center" richColors closeButton />
      </PlannerEventProvider>
      </FavoriteServicesProvider>
    </AuthProvider>
  )
}

